import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatMode } from '@common/components/tab-chat/tab-chat.component';
import { ChatService } from '@common/services/chat.service';
import { ModalService } from '@common/services/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@services/toast.service';
import { ChatCounterService, ChatUnreadCounts } from 'app/singleton-services/chat-counter.service';
import { FormSafeNavigationService } from 'app/singleton-services/form-safe-navigation.service';
import { Subscription } from 'rxjs';
import { BaseRestEditController } from './../../common/classes/base-rest-edit-controller';

@Component({
    selector: 'app-chat-list',
    templateUrl: './chat-list.component.html',
    styleUrls: ['./chat-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatListComponent extends BaseRestEditController implements OnInit, OnDestroy {
    // Make ChatMode available in template
    ChatMode = ChatMode;

    breadcrumb = [
        {
            icon: 'comments',
            title: this.translateService.get('Chat')
        }
    ];

    unreadCounts: ChatUnreadCounts = {
        total: 0,
        general: 0,
        vesselVisit: 0,
        serviceRequest: 0,
        storageDocument: 0,
        amendmentDocument: 0,
        sent: 0
    };

    private chatCounterSubscription: Subscription;

    constructor(
        private service: ChatService,
        router: Router,
        activatedRoute: ActivatedRoute,
        toastyService: ToastService,
        location: Location,
        dialogService: ModalService,
        translateService: TranslateService,
        formSafeNavigation: FormSafeNavigationService,
        private chatCounterService: ChatCounterService
    ) {
        super(router, activatedRoute, toastyService, location, dialogService, translateService, formSafeNavigation);
    }

    ngOnInit(): void {
        // Subscribe to chat counter updates
        this.chatCounterSubscription = this.chatCounterService.counts$.subscribe((counts) => {
            this.unreadCounts = counts;
        });
    }

    ngOnDestroy(): void {
        if (this.chatCounterSubscription) {
            this.chatCounterSubscription.unsubscribe();
        }
    }
}
